var _g, _path, _path2, _line, _line2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreatedAt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1452_835)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.9751,
    cy: 18,
    r: 16,
    fill: "#EDEFFD"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5752 22.8002V14.8002C12.5752 14.3758 12.7438 13.9689 13.0438 13.6688C13.3439 13.3688 13.7508 13.2002 14.1752 13.2002H23.7752C24.1995 13.2002 24.6065 13.3688 24.9066 13.6688C25.2066 13.9689 25.3752 14.3758 25.3752 14.8002V22.8002M12.5752 22.8002C12.5752 23.2245 12.7438 23.6315 13.0438 23.9316C13.3439 24.2316 13.7508 24.4002 14.1752 24.4002H23.7752C24.1995 24.4002 24.6065 24.2316 24.9066 23.9316C25.2066 23.6315 25.3752 23.2245 25.3752 22.8002M12.5752 22.8002V17.4669C12.5752 17.0425 12.7438 16.6355 13.0438 16.3355C13.3439 16.0354 13.7508 15.8669 14.1752 15.8669H23.7752C24.1995 15.8669 24.6065 16.0354 24.9066 16.3355C25.2066 16.6355 25.3752 17.0425 25.3752 17.4669V22.8002",
    fill: "#475BEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5752 22.8002V14.8002C12.5752 14.3758 12.7438 13.9689 13.0438 13.6688C13.3439 13.3688 13.7508 13.2002 14.1752 13.2002H23.7752C24.1995 13.2002 24.6065 13.3688 24.9066 13.6688C25.2066 13.9689 25.3752 14.3758 25.3752 14.8002V22.8002M12.5752 22.8002C12.5752 23.2245 12.7438 23.6315 13.0438 23.9316C13.3439 24.2316 13.7508 24.4002 14.1752 24.4002H23.7752C24.1995 24.4002 24.6065 24.2316 24.9066 23.9316C25.2066 23.6315 25.3752 23.2245 25.3752 22.8002M12.5752 22.8002V17.4669C12.5752 17.0425 12.7438 16.6355 13.0438 16.3355C13.3439 16.0354 13.7508 15.8669 14.1752 15.8669H23.7752C24.1995 15.8669 24.6065 16.0354 24.9066 16.3355C25.2066 16.6355 25.3752 17.0425 25.3752 17.4669V22.8002",
    stroke: "#EDEFFD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15.5751,
    y1: 12.1996,
    x2: 15.5751,
    y2: 14.1996,
    stroke: "#475BEB",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 22.7753,
    y1: 12.1996,
    x2: 22.7753,
    y2: 14.1996,
    stroke: "#475BEB",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.0252,
    cy: 18.75,
    r: 0.750006,
    fill: "#EDEFFD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5249,
    cy: 18.75,
    r: 0.750006,
    fill: "#EDEFFD"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.0256,
    cy: 18.75,
    r: 0.750006,
    fill: "#EDEFFD"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.0252,
    cy: 21.25,
    r: 0.750006,
    fill: "#EDEFFD"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5239,
    cy: 21.25,
    r: 0.750006,
    fill: "#EDEFFD"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5244,
    cy: 21.25,
    r: 0.750006,
    fill: "#EDEFFD"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.0237,
    cy: 21.25,
    r: 0.750006,
    fill: "#EDEFFD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1452_835",
    x: 0.975098,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.278431 0 0 0 0 0.356863 0 0 0 0 0.921569 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1452_835"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1452_835",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatedAt);
export default __webpack_public_path__ + "static/media/created-at.47c9d5b5dcf0bd056eec3d9b6961cedf.svg";
export { ForwardRef as ReactComponent };